import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { map } from 'rxjs/operators';
import { IReaction } from '../../../activity-feed/activity-feed';
import { ReactionsService } from '../../../services/reactions.service';
import { CommentsService } from '../../../services/comments.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-like-button',
  templateUrl: './like-button.component.html',
  styleUrls: ['./like-button.component.scss'],
})
export class LikeButtonComponent implements OnInit, OnDestroy {
  @Input() itemId: string;
  @Input() currentUserId: string;
  @Input() itemCollection: string;
  @Input() hideComments: boolean = false;
  @Output() commentClick = new EventEmitter<void>();

  likesCount: number = 0;
  commentsCount: number = 0;
  hasLiked: boolean = false;
  loadingLike: boolean = false;

  private destroy$ = new Subject<void>();

  constructor(
    private reactionsService: ReactionsService,
    private commentsService: CommentsService,
    private router: Router
  ) {}

  ngOnInit() {
    if (!this.itemId) return;

    // Initialize likes count and check if user has liked
    this.reactionsService
      .getReactions()
      .pipe(
        takeUntil(this.destroy$),
        map(
          reactions =>
            reactions.filter(r => r.id === this.itemId) as IReaction[]
        )
      )
      .subscribe(reactions => {
        const itemReaction = reactions[0];
        if (itemReaction) {
          const likes = itemReaction.likes || [];
          this.likesCount = likes.length;
          this.hasLiked = this.currentUserId
            ? likes.includes(this.currentUserId)
            : false;
        } else {
          this.likesCount = 0;
          this.hasLiked = false;
        }
        this.loadingLike = false;
      });

    // Initialize comments count
    this.commentsService
      .getCommentCount(this.itemId, this.itemCollection)
      .pipe(takeUntil(this.destroy$))
      .subscribe(count => {
        this.commentsCount = count || 0;
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  putLikeOrDislike() {
    this.loadingLike = true;
    try {
      this.reactionsService.putLikeOrDislike(this.itemId, this.itemCollection);
    } finally {
      this.loadingLike = false;
    }
  }

  goToComments() {
    if (
      this.itemCollection === 'events' ||
      this.itemCollection === 'secondHand' ||
      this.itemCollection === 'pools'
    ) {
      // Emit an event that the parent component can listen to
      this.commentClick.emit();
    } else {
      // For other item types like activity feed posts, navigate to their detail page
      this.router.navigate(['/activity-feed', this.itemId], {
        queryParams: { focusComments: true },
      });
    }
  }
}

